import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { CheckboxAdapter, SidebarButtonGroup, SidebarTitle } from '../../../shared/components';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';
import { IGroupVisibility, ITrajectoryDifferentiation } from 'src/config/api/models/Trajectory';
import {
  DifferentiationsOverviewWrapper,
  ListItemWrapper,
  ListWrapper,
  OtherDifferentiationIndicator,
  StyledListItem,
} from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  handleSubmit: () => void;
  bookGroupVisibility: IGroupVisibility[];
  differentiations: ITrajectoryDifferentiation[];
  currentDifferentiationId: string;
  openCallback: (screen: DifferentiationScreenAction, meta?: object) => void;
};

export const DifferentiationVisibilityForm: FC<Props> = ({
  handleSubmit,
  openCallback,
  bookGroupVisibility,
}) => {
  const { t } = useTranslation();

  return (
    <DifferentiationsOverviewWrapper>
      <form onSubmit={handleSubmit}>
        <SidebarTitle
          title={t('differentiations.manageVisibility')}
          icon={SpriteIconsLight.VISIBLE}
        />
        <ListWrapper>
          {bookGroupVisibility.map((item) => {
            return (
              <ListItemWrapper key={item.id}>
                <StyledListItem className="listItem">
                  <Field
                    name={item.id}
                    component={CheckboxAdapter}
                    type="checkbox"
                    label={
                      <>
                        {item.name} {item.isDefaultGroup && 'Klasgroep'}
                        {item.isDisabled && (
                          <OtherDifferentiationIndicator>
                            {` (${t('differentiations.seesOtherDifferentiation')} ${
                              item.disabledReason
                            })`}
                          </OtherDifferentiationIndicator>
                        )}
                      </>
                    }
                    disabled={item.isDisabled}
                  />
                </StyledListItem>
              </ListItemWrapper>
            );
          })}
        </ListWrapper>
        <SidebarButtonGroup
          icon={SpriteIconsLight.CIRCLE_PLUS}
          submitText={t('shared.save')}
          hasCancelButton
          cancelCallback={() => openCallback(DifferentiationScreenAction.OVERVIEW)}
          cancelText={t('shared.forms.cancel')}
        />
      </form>
    </DifferentiationsOverviewWrapper>
  );
};
